<template>
    <hts-drawer
        v-model="visible"
        :size="60"
        :title="indexTollStation === undefined ? $t('labels.addTollStation') : $t('labels.editTollStation')"
        :submit="handleSubmit"
        :rules="rules"
        @close="closeOverSideTollStation">
        <div class="pb-9 px-5 mt-5 grid grid-cols-1 gap-5">
            <hts-admincp-select-node
                v-model="formAddTollStationPrice.tollStation"
                v-model:text="formAddTollStationPrice.tollStationName"
                type="TOLL_STATION"
                required
                key-id="_id"
                key-label="locationName"
                :clearable="true"
                prop="node"
                name="node" />
            <hts-form-radio
                v-model="formAddTollStationPrice.calculatedBy"
                :label="$t('labels.calculatedBy')"
                value-key="value"
                required
                :items="listCheckBoxTypeGoodsTypes"
                name="calculatedBy"
                prop="calculatedBy" />
            <hts-form-date
                v-model="formAddTollStationPrice.from"
                :label="$t('labels.from')"
                type="date"
                required
                :color="props.color"
                name="from"
                prop="from" />
            <hts-form-date
                v-model="formAddTollStationPrice.to"
                :label="$t('labels.to')"
                type="date"
                disabled
                :color="props.color"
                name="to"
                prop="to" />
        </div>
    </hts-drawer>
</template>
<script setup lang="ts">
import { ITollStation } from './imports/form'

const props = defineProps({
  showPopupAddTollStation: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  vehicleIsSelected: {
    type: Object,
    default: () => {}
  }
})

const { showPopupAddTollStation } = toRefs(props)

const emits = defineEmits(['submitTollStation', 'close', 'submit'])
const formAddTollStationPrice = ref<ITollStation>({
  tollStation: '',
  from: '',
  to: '',
  calculatedBy: '',
  tollStationName: ''
})
const visible = ref(false)
const indexTollStation = ref<number | undefined>()
const open = (index?: number, item?: ITollStation) => {
  visible.value = true
  indexTollStation.value = index
  formAddTollStationPrice.value = {
    tollStation: '',
    from: '',
    to: '',
    calculatedBy: '',
    tollStationName: ''
  }
  if (typeof index === 'number' && item) {
    formAddTollStationPrice.value = { ...item }
    formAddTollStationPrice.value.tollStationName = item.tollStationName || item.tollStationDetail?.name
  }
}
defineExpose({
  open
})

const closeOverSideTollStation = () => {
  visible.value = false
  undo()
}

const undo = () => {
  formAddTollStationPrice.value = {
    tollStation: '',
    from: '',
    to: '',
    calculatedBy: '',
    tollStationName: ''
  }
}

const rules = {
  node: 'required',
  calculatedBy: 'required',
  from: 'required'
}
// const autoRules = computed(() => {
//   const result = { ...rules }
//   if (formAddTollStationPrice.value?.from) {
//     result.to = 'required|date_bigger:' + formAddTollStationPrice.value.from
//   }
//   return result
// })

const handleSubmit = () => {
  const formAsPlainObject = toRaw(formAddTollStationPrice.value)
  emits('submit', formAsPlainObject, formAsPlainObject?.tollStation, indexTollStation.value)
  visible.value = false
}

const listCheckBoxTypeGoodsTypes = [
  { value: 'MONTH', label: $t('labels.month') },
  { value: 'QUARTER', label: $t('labels.quarter') }
]

watch(
  () => formAddTollStationPrice?.value?.from,
  (val) => {
    updateToDate()
  }
)

watch(
  () => formAddTollStationPrice?.value?.calculatedBy,
  (val) => {
    updateToDate()
  }
)

const updateToDate = () => {
  if (!formAddTollStationPrice?.value?.from) {
    formAddTollStationPrice.value.to = ''
    return
  }

  let from: null | Date = null

  if (formAddTollStationPrice?.value?.calculatedBy === 'MONTH') {
    from = new Date(formAddTollStationPrice?.value?.from)
    from.setDate(from.getDate() + 29)
  }

  if (formAddTollStationPrice?.value?.calculatedBy === 'QUARTER') {
    from = new Date(formAddTollStationPrice?.value?.from)
    from.setDate(from.getDate() + 89)
  }

  if (from) {
    const year = from.getFullYear()
    const month = String(from.getMonth() + 1).padStart(2, '0')
    const day = String(from.getDate()).padStart(2, '0')
    const to = `${year}-${month}-${day}`

    formAddTollStationPrice.value.to = to
    return
  }

  formAddTollStationPrice.value.to = ''
}
</script>
